import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="px-4 sm:px-6 pt-14 sm:pt-16 pb-8 sm:pb-10 mt-8 sm:mt-10 border-t border-neutral-900/15">
      <div className="max-w-[1360px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10">
        <div className="col-span-2">
          <img
            src="/images/alfa-logo-black.png?v=2"
            alt="ALFÀ"
            className="h-9 sm:h-10 w-auto object-contain"
          />
          <p className="mt-4 text-[15px] sm:text-[15.5px] text-neutral-950 max-w-sm">
            Physician-led GLP-1 weight loss programs. Cash-pay, no insurance, no waiting rooms.
          </p>
          <a
            href="https://www.legitscript.com/websites/alfameds.com"
            target="_blank"
            rel="noopener noreferrer"
            title="Verify LegitScript Approval for www.alfameds.com"
            data-testid="footer-legitscript-badge"
            className="block w-fit mt-5"
          >
            <img src="https://static.legitscript.com/seals/52460149.png" alt="Verify Approval for www.alfameds.com" width="73" height="79" />
          </a>
        </div>
        <div>
          <p className="uppercase text-[12.5px] tracking-[0.2em] text-neutral-950 font-semibold">Categories</p>
          <ul className="mt-4 space-y-2 text-[15px] text-neutral-950">
            <li><Link className="nav-link" to="/#arsenal" data-testid="footer-link-weight-loss">Weight Loss</Link></li>
          </ul>
        </div>
        <div>
          <p className="uppercase text-[12.5px] tracking-[0.2em] text-neutral-950 font-semibold">Company</p>
          <ul className="mt-4 space-y-2 text-[15px] text-neutral-950">
            <li><Link className="nav-link" to="/about" data-testid="footer-link-about">About</Link></li>
            <li><Link className="nav-link" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            <li><Link className="nav-link" to="/privacy" data-testid="footer-link-privacy">Privacy</Link></li>
            <li><Link className="nav-link" to="/terms" data-testid="footer-link-terms">Terms</Link></li>
            <li><Link className="nav-link" to="/refund" data-testid="footer-link-refund">Refund</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1360px] mx-auto mt-14 flex flex-col md:flex-row justify-between gap-3 text-[13.5px] text-neutral-950">
        <p>© {new Date().getFullYear()} ALFÀ Health. All rights reserved.</p>
        <p>Not medical advice. Consult a licensed provider.</p>
      </div>
    </footer>
  );
}
